import { metaForPath, type RouteMeta } from "./metadata";

interface SeoProps {
  route: string;
}

// React 19 hoists <title> and <meta> rendered anywhere in the tree into
// <head>, so this keeps the browser tab and meta tags correct during
// client-side navigation. Server-side injection (see seo/inject.ts) covers
// the initial response for crawlers.
export function Seo({ route }: SeoProps) {
  const { meta }: { meta: RouteMeta } = metaForPath(route);
  return (
    <>
      <title>{meta.title}</title>
      <meta name="description" content={meta.description} />
    </>
  );
}
